import { render, staticRenderFns } from "./editAddApproverDialog.vue?vue&type=template&id=0b97e97d&scoped=true"
import script from "./editAddApproverDialog.vue?vue&type=script&lang=js"
export * from "./editAddApproverDialog.vue?vue&type=script&lang=js"
import style0 from "./editAddApproverDialog.vue?vue&type=style&index=0&id=0b97e97d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97e97d",
  null
  
)

export default component.exports